export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Calcolo del risparmio in Walutomat',
    forBuy: 'per',
    unsupportedPair: 'Al momento non offriamo tassi per la coppia di valute selezionata.',
    spinnerError: {
      generic: 'Si è verificato un problema nel download dei dati',
      toManyRequests:
        'Il calcolatore è attualmente utilizzato da molti utenti. Riprova più tardi o contatta il Servizio clienti. <a href="https://www.walutomat.com/it/contatto/">https://www.walutomat.com/it/contatto/</a>',
    },
    commissionWT: 'Commissione Walutomat',
    continueButton: 'Continua lo scambio',
    amountText: 'Importo',
  },
  continueButton: {
    createAccount: 'Crea un account gratuito',
    logIn: 'Accedi',
    check: 'Verifica',
    checkWhyWorth: 'perché ne vale la pena',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title:
      'Controlla i tassi di cambio e{{nbsp}}converti la valuta in{{nbsp}}Walutomat – in modo rapido e{{nbsp}}vantaggioso.',
    actualRate: 'Tasso di cambio attuale',
    buySelect: 'Compro',
    sellSelect: 'Vendo',
    buttonText: 'Converti',
    exchangeAmountSellLabel: 'Riceverai',
    exchangeAmountBuyLabel: 'Deposito',
    commission: 'Commissione promozionale ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Il campo non può essere vuoto',
    requiredField: 'Il campo è obbligatorio',
    requireAllFields: 'Tutti i campi devono essere compilati',
    passwordToShort: 'La password deve essere di 8 caratteri',
    emailNotValid: 'Il campo deve contenere un indirizzo e-mail valido',
    emailReserved: "L'indirizzo e-mail è già occupato",
    emailUnregistered: 'Non abbiamo trovato il tuo indirizzo e-mail nel nostro database clienti.',
    markField: 'Seleziona almeno una delle caselle di controllo',
    serverUnknownError: 'Errore di comunicazione del server',
    invalidCharacters: 'Il campo contiene caratteri non validi',
    phoneNotValid: 'Il numero di telefono non è corretto',
    checkBoxBelow: 'Selezionare la casella sottostante per inviare un messaggio',
    promocodeInvalid: 'Codice promozionale non valido',
    newsletterAlreadySubscribed: 'Questa email è già iscritta alla newsletter.',
  },
  password: {
    show: 'mostrare',
    hide: 'nascondere',
  },
  howItWorks: {
    showButton: 'Mostra di più',
    hideButton: 'Mostra meno',
  },
}
